/**
 * UsersReportsCtrl controller
 *
 * @class UsersReportsCtrl
 * @memberof mwApp/usersReportsCtrl
 * @see mwApp/usersReportsCtrl
 * @mixes mwApp/common.mixin:tabsCtrlMixin
 *
 * @ngdoc controller
 * @name mwApp/usersReportsCtrl.controller:UsersReportsCtrl
 */
/* @ngInject */
export default function UsersReportsCtrl ($scope, $window, authSvc) {
  var vm = this
  vm.mixes = authSvc.hasAccess('createActivationAuditReport')
    ? [['tabsCtrlMixin', '', 'reports_list', 'generated_reports']]
    : [['tabsCtrlMixin', '']]

  /**
   * Methods to change tab
   *
   * @memberof mwApp/reports.controller:UsersReportsCtrl
   */
  vm.toChangeTab = function (tabName) {
    $scope.$broadcast(`dispatch: ${tabName}`)
  }
}
